import _ from 'underscore';

export default (function (currentVmNode, question, answers) {
    return {
        'visible': {
            'get': function get() {
                return _.every(question.filters, function (filter) {
                    return answers[filter.questionCode] === filter.answer;
                });
            }
        },
        'required': {
            'get': function get() {
                return currentVmNode.aspects.visible && question.required;
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-js/aspects/Requiredness.js
// module id = 1362
// module chunks = 0